import { render, staticRenderFns } from "./EvaluationFreeExploration.vue?vue&type=template&id=5e338f1d&"
import script from "./EvaluationFreeExploration.vue?vue&type=script&lang=js&"
export * from "./EvaluationFreeExploration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e338f1d')) {
      api.createRecord('5e338f1d', component.options)
    } else {
      api.reload('5e338f1d', component.options)
    }
    module.hot.accept("./EvaluationFreeExploration.vue?vue&type=template&id=5e338f1d&", function () {
      api.rerender('5e338f1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Home/components/EvaluationFreeExploration.vue"
export default component.exports